<template>
    <div v-if="receiptHTML">
        <div class="text-subtitle">Order Receipt</div>
        <q-card class="bg-white q-mt-sm">
            <q-card-section v-if="order">
                <vue-custom-scrollbar class="scroll-area" :settings="settings" style="border: none!important;">
                    <div v-html="receiptHTML" />
                </vue-custom-scrollbar>
            </q-card-section>
        </q-card>
    </div>
</template>
<script>

    import { mapState } from 'vuex'
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        name: 'order-receipt',
        components: {
            vueCustomScrollbar
        },
        props: {
            order: Object,
        },
        data() {
            return {
                enumSendEmailTo: 0,
                showConfirmSend: false,
                emailRecipient: '',
                expanded: false,
                settings: {
                    suppressScrollY: false,
                    suppressScrollX: false,
                    wheelPropagation: true
                }
            }
        },
        methods: {
            sendEmail() {
                const payload = {
                    enumRecipients: this.enumSendEmailTo,
                    orderId: this.order.orderID
                }
                this.$store.dispatch('sendReceiptEmail', payload).then(() => {
                    this.showConfirmSend = false
                    this.$q.notify({
                        badgeClass: 'hidden',
                        type: 'positive',
                        message: 'Email has been sent'
                    })
                })
            },
            showSendDialog(recipient, enumSendEmailTo) {
                this.enumSendEmailTo = enumSendEmailTo
                this.emailRecipient = recipient
                this.showConfirmSend = true
            }
        },
        computed: {
            ...mapState([
                'sendReceiptEmailPending',
                'sendReceiptEmailData',
            ]),
            receiptHTML() {
                if (this.order.receiptHTML) {
                    if (this.$q.dark.isActive)
                        return this.order.receiptHTML.replaceAll('#FFFFCC', '#181818')
                    else
                        return this.order.receiptHTML
                }
                return ''
            }
        },
    }
</script>
<style>
    .scroll-area {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>
